export default function IconAddress() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
                d="M7.24443 15.4893C5.27607 15.9941 4 16.8044 4 17.718C4 19.2485 7.58172 20.4893 12 20.4893C16.4183 20.4893 20 19.2485 20 17.718C20 16.8219 18.7724 16.0252 16.8681 15.5186"
                stroke="#707070"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.25 8.8335C17.25 12.9168 12 16.4168 12 16.4168C12 16.4168 6.75 12.9168 6.75 8.8335C6.75 7.44111 7.30312 6.10575 8.28769 5.12119C9.27226 4.13662 10.6076 3.5835 12 3.5835C13.3924 3.5835 14.7277 4.13662 15.7123 5.12119C16.6969 6.10575 17.25 7.44111 17.25 8.8335Z"
                stroke="#707070"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12 10.5835C12.9665 10.5835 13.75 9.79999 13.75 8.8335C13.75 7.867 12.9665 7.0835 12 7.0835C11.0335 7.0835 10.25 7.867 10.25 8.8335C10.25 9.79999 11.0335 10.5835 12 10.5835Z"
                stroke="#707070"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
